import React from 'react';

function Icon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 16 16'
    >
      <path d='M3.5 2C2.676 2 2 2.676 2 3.5v9c0 .824.676 1.5 1.5 1.5h9c.824 0 1.5-.676 1.5-1.5v-9c0-.824-.676-1.5-1.5-1.5zm0 1h9c.281 0 .5.219.5.5v9c0 .281-.219.5-.5.5h-9a.494.494 0 01-.5-.5v-9c0-.281.219-.5.5-.5zM5 10v1h6v-1z'/>
    </svg>
  );
}

export default Icon;
